import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadFaqs, loadSection } from "../services/contentSource";
import faqData from "../data/faqData.json";
import headerFallback from "../data/home/faqHeader.json";

const FaqSection = () => {
  const [faqs, setFaqs] = useState<any[]>(faqData.faqs || []);
  const [header, setHeader] = useState<any>(headerFallback);
  const [openId, setOpenId] = useState<number | null>(0); // First item open by default

  useEffect(() => {
    loadFaqs().then((data) => {
      if (data) setFaqs(data);
    });
    loadSection("homeFaq", headerFallback as any).then(({ data: main }) => {
      if (main) setHeader(main);
    });
  }, []);

  const toggleFaq = (index: number) => {
    setOpenId((prev) => (prev === index ? null : index));
  };

  return (
    <section className="faq-area mx-faq-revamp" id="faq">
      <div className="container mx-container">
        <div className="mx-faq-grid">
          {/* Left Column: Badge, Headline, Description & Architect Card */}
          <div className="mx-faq-header-column">
            <div className="mx-hero-badge">
              <span className="mx-hero-badge-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01"></path>
                </svg>
              </span>
              <span>{header.badgeText}</span>
            </div>

            <h2 className="mx-faq-title">
              {header.title}
            </h2>

            <p className="mx-faq-lede">
              {header.lede}
            </p>

            {/* Quick Consultation Pill Card */}
            <div className="mx-faq-consult-card">
              <div className="mx-faq-consult-header">
                <span className="mx-about-dot-pulse"></span>
                <span className="mx-faq-consult-tag">{header.consultTag}</span>
              </div>
              <p className="mx-faq-consult-text">
                {header.consultText}
              </p>
              <Link to="/contact" className="mx-hero-btn-primary mx-faq-consult-btn">
                <span>{header.consultButtonText}</span>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
          </div>

          {/* Right Column: Modern Animated Accordion */}
          <div className="mx-faq-list-column">
            <div className="mx-faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openId === index;
                const padIndex = String(index + 1).padStart(2, "0");

                return (
                  <div
                    className={`mx-faq-card ${isOpen ? "mx-faq-card-active" : ""}`}
                    key={faq._id || faq.id || index}
                  >
                    <button
                      type="button"
                      className="mx-faq-header-btn"
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isOpen}
                    >
                      <span className="mx-faq-num-badge">{padIndex}</span>
                      <span className="mx-faq-q-text">{faq.question}</span>
                      <span className={`mx-faq-chevron ${isOpen ? "mx-faq-chevron-open" : ""}`} aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </button>

                    {isOpen && (
                      <div className="mx-faq-answer-wrap">
                        <div className="mx-faq-answer-inner">
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
